// extracted by mini-css-extract-plugin
module.exports = {"newsfeedCard":"of-z"};